export default {
  methods: {
    toHex(str) {
      let hex = "";
      for (let i = 0; i < str.length; i++) {
        hex += "" + str.charCodeAt(i).toString(16);
      }
      return hex;
    },
    processNotificationParameters(strPayload) {
      if (!strPayload) {
        throw new Error("Payload is required");
      }

      if (typeof strPayload !== "string") {
        throw new Error("Payload must be a base-64 encoded string");
      }

      const payload = JSON.parse(
        decodeURIComponent(Buffer.from(strPayload, "base64").toString("utf8"))
      );

      return payload || null;
    },
    checkCorrectDSResponse(codeString) {
      console.log("checkCorrectDSResponse Ds_Response::: ", codeString);
      // check expected success Ds_Response "0000" -  "0099"
      let s1 = codeString[0] + codeString[1];
      if (s1 === "00") {
        const res = parseInt(codeString[2] + codeString[3]);
        if (res >= 0 && res <= 99) {
          // Correct Ds_Response code range  "0000" -  "0099"
          console.log("Success Ds_Response::: ", codeString);
          return true;
        } else {
          return false;
        }
      }
      return false;
    }
  }
};
